import {SurveyRepository} from "@/survey/repository/SurveyRepository";
import Survey from "@/survey/model/Survey";
import AdminApiClient, {SurveyRequest} from "@/synchronizer/service/AdminApiClient";
import Encryptor from "@/core/service/Encryptor";

export class Synchronizer {
    private readonly repository: SurveyRepository;

    constructor() {
        this.repository = new SurveyRepository();
    }

    public async sync(): Promise<number> {
        let sent = 0;
        await this.repository.initDB();
        const surveys = await this.getSurveys();
        for (const survey of surveys) {
            const res = await this.sendSurvey(survey);
            if (res && survey.id) {
                sent++;
                await this.deleteSurvey(survey.id);
            }
        }
        this.repository.dispose();
        return sent;
    }

    private async getSurveys(): Promise<Survey[]> {
        try {
            return await this.repository.getAllSurveys();
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    private async sendSurvey(survey: Survey): Promise<boolean> {
        try {
            const surveyRequest: SurveyRequest = {
                ...survey,
                ...{token: await Encryptor.encrypt(process.env.VUE_APP_TOKEN_API)}
            };
            await AdminApiClient.sendSurvey(surveyRequest);
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    private async deleteSurvey(id: number): Promise<void> {
        try {
            await this.repository.deleteSurvey(id);
        } catch (e) {
            console.error(e);
        }
    }
}
